<template>

    <v-card class="common-object-item-picker-card" max-width="290" width="290" height="220">
        <span class="card-title">Set to Common Object</span>
        
        <v-card-text>

            <v-autocomplete class="common-object-input" color="#c42111" label="Common Object" v-model="selectedObjectId" :items="$props.commonObjects" item-text="object_name" item-value="object_id" outlined dense clearable />

            <v-autocomplete class="common-object-input mt-2" color="#c42111" label="Item" v-model="selectedItemId" :items="objectItems" item-text="item_name" item-value="item_id" outlined dense clearable :disabled="!selectedObjectId">
                <template v-slot:append-outer>
                    <v-menu offset-x :close-on-content-click="false" right nudge-right="15" :nudge-top="selectedItemObj ? (selectedItemObj.item_field_values.length * 30) : 0">
                        <template v-slot:activator="{ on, attrs }">
                            <v-icon v-bind="attrs" :disabled="!selectedItemId" v-on="on">mdi-information-outline</v-icon>
                        </template>

                        <common-object-item-info :nodeValue="$props.nodeValue" :objectId="selectedObjectId" :itemId="selectedItemId" :commonObjects="$props.commonObjects" />

                    </v-menu>
                </template>
            </v-autocomplete>
            
        </v-card-text>

        <v-divider />
        <v-card-actions>
            <v-btn class="" width="33%" text @click="$emit('cancel')">Cancel</v-btn>
            <v-btn class="" width="33%" text @click="$emit('clear')">Clear</v-btn>
            <v-btn class="button" width="33%" text :disabled="!selectedObjectId || !selectedItemId" @click="setClick">Set</v-btn>
        </v-card-actions>

    </v-card>

</template>

<script>
import CommonObjectItemInfo from "@/components/Sites/CommonObjectItemInfo";
export default {
    name: 'CommonObjectItemPicker',
    props: ['nodeValue', 'commonObjects'],
    components: {
        CommonObjectItemInfo
    },
    data: () => ({
        value: null,
        selectedObjectId: null,
        selectedItemId: null
    }),

    computed: {
        selectedObjectObj() {
            if(this.selectedObjectId) {
                return this.$props.commonObjects.find(c => c.object_id == this.selectedObjectId);
            }
            return null;
        },

        selectedItemObj() {
            if(this.selectedObjectId && this.selectedItemId) {
                return this.selectedObjectObj.items.find(i => i.item_id == this.selectedItemId);
            }
            return null;
        },

        objectItems() {
            if(this.selectedObjectId) {
                return this.$props.commonObjects.find(c => c.object_id == this.selectedObjectId).items;
            }
            return [];
        }
    },

    methods: {
        setClick: function() {
            if(!(this.selectedObjectId && this.selectedItemId)) {
                return;
            }
            let itemNodeValueObj = {
                item_id: this.selectedItemId,
                node_id: this.$props.nodeValue.node_id,
                node_value: this.selectedItemObj.item_name,
                object_id: this.selectedObjectId
            }
            this.$emit('item', itemNodeValueObj);
        }
    },

    created() {
    },

    mounted() {
        if(this.$props.nodeValue.item_id != -1) {
            this.selectedObjectId = this.$props.nodeValue.object_id;
            this.selectedItemId = this.$props.nodeValue.item_id;
        }
        
    },

    watch: {

    },

  
};
</script>

<style scoped>

    .common-object-item-picker-card {
        border: solid 1px rgba(0, 255, 255, 0.6);
    }

    .common-object-item-picker-card .card-title {
        font-size: 17px;
        font-weight: bold;
        margin-top: 10px;
        text-align: center;
        display: block;
    }

    .common-object-item-picker-card .common-object-input {
        padding-top: 0px;
        margin-top: 0px;
        min-height: 45px;
        height: 45px;
    }

    .common-object-item-picker-card .button:hover {
        color: #00ffff;
    }

    .arrow {
        width: 0;
        height: 0;
        border-top: 15px solid transparent;
        border-bottom: 15px solid transparent;
        border-right: 15px solid #00ffff;
        transform: rotate(90deg);
        position: absolute;
        top: 20px;
        left: 20px;
        z-index: 9999999999999;
        display: block;
    }
    .arrow::after {
        content: '';
        width: 0;
        height: 0;
        border-top: 15px solid transparent;
        border-bottom: 15px solid transparent;
        border-right: 15px solid #424242;
        position: absolute;
        top: -15px;
        left: 1px;
    }

</style>

<style>

    /* .common-object-item-picker-card .common-object-input .v-select__slot {
        min-height: 45px !important;
        height: 45px !important;
    }

    .common-object-item-picker-card .common-object-input fieldset {
        min-height: 45px !important;
        height: 45px !important;
    }

    .common-object-item-picker-card .common-object-input.v-text-field--outlined .v-label {
        top: 12px !important;
    }

    .common-object-item-picker-card .common-object-input.v-text-field--outlined .v-label--active {
        top: 18px !important;
    } */

</style>

